// Toggles the mobile primary navigation from the header's hamburger button.
// The open state lives on the shared `.site-header__right` wrapper (not the
// nav itself) so the nav and the CTA buttons reveal together regardless of
// their order in the markup.
export function initNavToggle() {
  const toggle = document.querySelector('.nav-toggle');
  const wrapper = document.querySelector('.site-header__right');
  const nav = document.getElementById('primary-navigation');

  if (!toggle || !wrapper || !nav) return;

  toggle.addEventListener('click', () => {
    const isOpen = wrapper.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', String(isOpen));

    // The drawer covers the full viewport and scrolls itself while open;
    // without this the page underneath stays scrollable too, so two
    // scrollbars end up active (and fighting for touch/wheel input) at
    // once. Locked on both html and body for cross-browser safety.
    document.documentElement.classList.toggle('overflow-hidden', isOpen);
    document.body.classList.toggle('overflow-hidden', isOpen);
  });
}
